export default function containsLowercaseValidator(val) {
    const regexLowercase = /[a-z]/;
    return val && regexLowercase.test(val);
}